import {
  SearchFacetIntervalRange,
  SearchFacetListItem,
  SearchFacetSetting,
} from 'src/types';

export enum SearchFacetType {
  SEARCH_FACET_INTERVAL = 'SearchFacetInterval',
  SEARCH_FACET_LIST = 'SearchFacetList',
}

export enum SearchProductFacetEnum {
  CATEGORY_ID = 'category_id',
  BRAND_ID = 'brand_id',
  LOWEST_PRICE = 'lowest_price',
  USER_RATING = 'user_rating',
}

export type SearchProductFacet =
  | 'category_id'
  | 'brand_id'
  | 'lowest_price'
  | 'user_rating';

export type Filter = {
  options: (
    | (SearchFacetListItem & { value?: string })
    | SearchFacetIntervalRange
  )[];
  title: string;
  type: SearchFacetType;
  id: string;
};

export type InitialFilters = {
  [key in SearchProductFacetEnum]: SearchFacetSetting;
};
